<template>
  <div>
    <Modal :footer-hide="!isAuth" :mask-closable="false" v-model="show" :title="title" :width="700" @on-cancel="reList()">
      <span class="markerpen">
        <font>{{ $state["projectStatus"][row.status] }}</font>
      </span>
      <table class="QHtable">
        <tr>
          <th colspan="10"><b>工地信息</b></th>
        </tr>
        <tr>
          <td style="width: 125px"><b>工地名称</b></td>
          <td colspan="3">
            <p>NO.{{ row.NO }}{{ row.name }}</p>
          </td>
        </tr>
        <tr>
          <td style="width: 125px"><b>工地地址</b></td>
          <td colspan="3">
            <p>{{ row.addressFull }}</p>
          </td>
        </tr>
        <tr>
          <td style="width: 125px"><b>工地类型</b></td>
          <td style="width: 150px">{{ $state["projectType"][row.projectType] }}</td>
          <td style="width: 110px; text-align: center"><b>联单查询</b></td>
          <td style="width: 150px">{{ $decryptToId(row.id) }}</td>
        </tr>
        <tr>
          <td style="width: 125px"><b>垃圾类型</b></td>
          <td style="width: 150px">{{ row.garbageTypeName }}</td>
          <td style="width: 110px; text-align: center"><b>垃圾名称</b></td>
          <td>{{ row.garbageName }}</td>
        </tr>
        <tr>
          <td style="width: 125px"><b>垃圾数量</b></td>
          <td style="width: 150px">
            <p v-if="row.garbageNumber != 0">{{ row.garbageNumber }}m³</p>
            <p v-else>运输后结算</p>
          </td>
          <td style="width: 110px; text-align: center"><b>垃圾图片</b></td>
          <td>
            <span class="CL1" v-if="$isblank(row.waste_img)">暂无图片</span>
            <span class="QHset" v-else @click="$openImg($getFritImg(row.waste_img))">查看</span>
          </td>
        </tr>
        <tr>
          <td style="width: 110px; text-align: center"><b>备案情况</b></td>
          <td>
            <span class="CL1" v-if="row.filingStatus == -1">暂无备案</span>
            <span class="QHset" @click="hiFilingPop(row.filingId)" v-else>{{ $state["filingStatus"][row.filingStatus] }}(查看)</span>
          </td>
          <td style="width: 110px; text-align: center"><b>小程序码</b></td>
          <td>
           
            <p v-if="!$isblank(row.qcodeUrl)">
              <span class="QHset" @click="$openImg(row.qcodeUrl)">查看</span>
            </p>
          </td>
        </tr>
        <tr>
          <th colspan="10"><b>排放单位</b></th>
        </tr>
        <tr>
          <td><b>排放单位</b></td>
          <td colspan="3">{{ row.paifangName }}</td>
        </tr>
        <tr>
          <td><b>联系客户</b></td>
          <td colspan="3">{{ row.contactName }} {{ row.contactTel }}</td>
        </tr>
        <tr>
          <th colspan="10"><b>服务作业</b></th>
        </tr>
       
        <tr>
          <td><b>运输作业单位</b></td>
          <td colspan="3">
            <p v-if="!$isblank(row.yunshuName)">{{ row.yunshuName }}</p>
            <p v-else class="CL1">运营服务单位设置异常</p>
          </td>
        </tr>
        <tr>
          <td><b>出场电子围栏</b></td>
          <td colspan="3">
            <p v-if="row.isChuchangweilan == 100">需要出场电子围栏（开启后司机在1500米范围之外不可出场）</p>
            <p v-if="row.isChuchangweilan == 200">无需出场电子围栏（关闭后出场无电子围栏限制）</p>
          </td>
        </tr>
        <tr>
          <td><b>卸车电子围栏</b></td>
          <td colspan="3">
            <p v-if="row.isRuchangweilan == 100">需要卸车电子围栏（开启后司机必须在接收点指定围栏范围卸车）</p>
            <p v-if="row.isRuchangweilan == 200">无需卸车电子围栏（关闭后司机卸车无电子围栏限制）</p>
          </td>
        </tr>
        <tr>
          <td><b>作业照片要求</b></td>
          <td colspan="3">
            <p v-if="$isArr('100', row.isNeedQingyunImg)">需要作业装车照片（作业时必须上传装车照片）</p>
            <p v-else-if="$isArr('200', row.isNeedQingyunImg)">需要作业卸车照片（作业时必须上传卸车照片）</p>
            <p v-else-if="$isArr('300', row.isNeedQingyunImg)">需要作业前后照片（作业时必须上传前后照片）</p>
            <p v-else class="CL1">作业照片要求设置异常</p>
          </td>
        </tr>
        <tr>
          <td><b>作业次数要求</b></td>
          <td colspan="3">
            <p v-if="row.isWorksCount == 100">单次作业（作业一车完成自动结束工地）</p>
            <p v-else-if="row.isWorksCount == 200">多次作业（作业多车完成手动结束工地）</p>
            <p v-else class="CL1">作业次数要求设置异常</p>
          </td>
        </tr>
      </table>
     
    </Modal>

   

    <!--组件区-->
    <filingEditDetailed ref="filingEditDetailed"></filingEditDetailed>
    <!--组件区 end-->
  </div>
</template>
<script>
import filingEditDetailed from "../../../filing/block/detailed/detailed";
export default {
  components: {
    filingEditDetailed,
  },
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      title: "工地详情",
      show: false,
      row: {},
      isAuth: false,
      //结算需要
      payShow: false,
      form: {
        payType: 100,
        payNote: "",
      },
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:唤起工地详情
    // +----------------------------------------------------------------------
    hiPop(e, isAuth) {
      this.isAuth = isAuth;
      this.$loading(true);
      var parameter = {};
      parameter["id"] = e.id;
      this.$api.getProjectDetailed(parameter).then((res) => {
        this.$loading(false);
        if (res.code == 0) {
          this.row = res.data;
          this.show = true;
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },

    // +----------------------------------------------------------------------
    // | Desc:唤起备案详情
    // +----------------------------------------------------------------------
    hiFilingPop(filingId) {
      this.$loading(true);
      var parameter = {};
      parameter["id"] = filingId;
      this.$refs.filingEditDetailed.hiPop(parameter);
    },


   
    // +----------------------------------------------------------------------
    // | Desc:费用结算
    // +----------------------------------------------------------------------
    clearFrom() {
      this.payShow = false;
      this.form = {
        payType: "",
        payNote: "",
      };
    },

    // +----------------------------------------------------------------------
    // | Desc:刷新主列表
    // +----------------------------------------------------------------------
    reList() {
      if (this.isAuth) {
        this.$emit("reList");
      }
    },
  },
};
</script>
<style>
.jiageCount {
  width: 310px;
  text-align: center;
}

.jiageCount .CL9 {
  font-size: 30px;
  font-weight: 700;
}
</style>
